import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { refillColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getRefill } from "../../../../api/sim";

const COPY_KEYS = [
  "id",
  "msisdn",
  "status",
  "transaction_id",
];

const RefillBatch = () => (
  <BatchDetail
    title="Refill"
    apiGet={__getRefill}
    client={CLIENTS.it}
    columnsFactory={refillColumns}
    copyKeys={COPY_KEYS}
    exportAction="refill"
    retryOperation="refill"
    showTerminate
    getRowPath={(row) => `/it/refill/${row.id}`}
  />
);

export default RefillBatch;
